<template>
  <div class="content package-student-page package-student-page--assign">
    <section ref="pageHero" class="ps-hero" :class="{ 'is-hidden': isHeroHidden }">
        <div class="ps-hero__main">
          <div class="ps-hero__icon"><i class="el-icon-school" /></div>
          <div>
            <h1>Áp dụng gói và theo dõi số lượng học sinh đang học của trường</h1>
            <p>Theo dõi mức sử dụng, số lượng học sinh đang học và trạng thái của từng trường trong hệ thống đang sử dụng gói.</p>
          </div>
        </div>
        <div class="ps-hero__actions">
          <el-button plain icon="el-icon-collection-tag" @click="$router.push('/package-student/packages')">
            Quản lý gói
          </el-button>
          <el-button plain icon="el-icon-setting" @click="openAlertConfigDialog">
            Cấu hình thông báo
          </el-button>
          <el-button type="primary" icon="el-icon-refresh" :loading="loading" @click="fetchData">
            Làm mới dữ liệu
          </el-button>
        </div>
    </section>

    <div class="ps-overview-sticky">
      <div ref="statsGrid" class="ps-stat-grid" :style="statsStyle">
        <div class="ps-stat-card">
          <div class="ps-stat-card__icon"><i class="el-icon-school" /></div>
          <div>
            <span class="ps-stat-card__value">{{ totalSchools }}</span>
            <span class="ps-stat-card__label">Tổng số trường</span>
          </div>
        </div>
        <div class="ps-stat-card ps-stat-card--orange">
          <div class="ps-stat-card__icon"><i class="el-icon-warning-outline" /></div>
          <div>
            <span class="ps-stat-card__value">{{ fullCount }}</span>
            <span class="ps-stat-card__label">Đạt / vượt giới hạn</span>
          </div>
        </div>
        <div class="ps-stat-card ps-stat-card--red">
          <div class="ps-stat-card__icon"><i class="el-icon-time" /></div>
          <div>
            <span class="ps-stat-card__value">{{ nearFullCount }}</span>
            <span class="ps-stat-card__label">Sắp đầy</span>
          </div>
        </div>
        <div class="ps-stat-card ps-stat-card--green">
          <div class="ps-stat-card__icon"><i class="el-icon-circle-check" /></div>
          <div>
            <span class="ps-stat-card__value">{{ assignedCount }}</span>
            <span class="ps-stat-card__label">Đã được áp dụng gói</span>
          </div>
        </div>
      </div>
    </div>

    <section class="ps-card ps-card--list" :style="cardLayoutStyle">
      <div ref="cardTop" class="ps-card__top">
        <div class="ps-card__heading">
        <div class="ps-card__heading-left">
          <div class="ps-card__heading-icon"><i class="el-icon-data-analysis" /></div>
          <div>
            <h2>Danh sách trường</h2>
            <p>Trạng thái đầy phản ánh mức sử dụng; quyền cho vượt giới hạn là cấu hình riêng của từng trường.</p>
          </div>
        </div>
        </div>

        <div class="ps-toolbar">
        <el-form class="ps-toolbar__filters" inline label-position="top" @submit.native.prevent>
          <el-form-item label="Chọn trường">
            <el-select
              v-model="schoolId"
              size="small"
              filterable
              clearable
              :loading="schoolOptionsLoading"
              placeholder="Chọn trường"
              style="width: 250px"
            >
              <el-option
                v-for="item in schoolOptions"
                :key="item.id"
                :value="item.id"
                :label="`${item.id} - ${item.schoolName}`"
              >
                <span>{{ item.id }}</span> -
                <span>{{ item.schoolName }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Trạng thái">
            <el-select v-model="statusFilter" size="small" style="width: 145px">
              <el-option label="Tất cả" value="ALL" />
              <el-option label="Chưa áp dụng" value="CHUA_GAN" />
              <el-option label="Còn số lượng" value="CON_SLOT" />
              <el-option label="Sắp đầy" value="SAP_DAY" />
              <el-option label="Đã đầy" value="DA_DAY" />
            </el-select>
          </el-form-item>
          <el-form-item label="Gói đang áp dụng">
            <el-select
              v-model="packageFilter"
              size="small"
              filterable
              clearable
              placeholder="Chọn gói"
              style="width: 220px"
            >
              <el-option
                v-for="item in packages"
                :key="item.id"
                :value="item.id"
                :label="`${item.code} - ${item.name}`"
              >
                <span>{{ item.code }}</span> -
                <span>{{ item.name }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div class="ps-toolbar__actions">
          <el-dropdown
            trigger="click"
            :disabled="bulkSaving"
            @command="handleBulkAction"
          >
            <el-button
              size="small"
              type="primary"
              plain
              :loading="bulkSaving"
            >
              Tác vụ <i class="el-icon-arrow-down el-icon--right" />
            </el-button>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item command="assign" icon="el-icon-connection">
                  Áp dụng gói cho nhiều trường
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
        </div>
      </div>

      <div class="ps-card__table">
        <el-table
          v-loading="loading"
          :data="filteredRows"
          border
          stripe
          class="sk-table ps-table"
          ref="schoolTable"
          :max-height="760"
          empty-text="Không tìm thấy trường phù hợp"
        >
        <el-table-column
          label="STT"
          type="index"
          width="56"
          align="center"
          fixed="left"
        />
        <el-table-column label="Mã / Tên trường" min-width="340" fixed="left">
          <template slot-scope="{ row }">
            <div class="ps-school-cell">
              <div class="ps-school-cell__avatar"><i class="el-icon-school" /></div>
              <div class="ps-school-cell__text">
                <span class="ps-school-cell__code">{{ row.school.id }}</span>
                <span class="ps-school-cell__name">{{ row.school.name }}</span>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="Gói đang áp dụng" min-width="240">
          <template slot-scope="{ row }">
            <template v-if="row.package">
              <span class="ps-package-code">{{ row.package.code }}</span>
              <span class="ps-package-name">{{ row.package.name }}</span>
              <el-tag v-if="!row.package.active" type="warning" size="mini" effect="plain">Gói đã ngưng</el-tag>
            </template>
            <span v-else class="ps-unassigned-state"><i class="el-icon-warning-outline" /> Chưa áp dụng gói</span>
          </template>
        </el-table-column>
        <el-table-column label="Ngày áp dụng" width="135" align="center">
          <template slot-scope="{ row }">
            <span v-if="row.assignment">{{ row.assignment.assignedAt | formatDate }}</span>
            <span v-else class="ps-row-muted">—</span>
          </template>
        </el-table-column>
        <el-table-column label="Số lượng thêm" width="110" align="center">
          <template slot-scope="{ row }">
            <span v-if="row.assignment" class="ps-addon-amount">{{ row.addonTotal | formatNumber }}</span>
            <span v-else class="ps-row-muted">—</span>
          </template>
        </el-table-column>
        <el-table-column label="Giới hạn hiệu lực" width="165" align="right">
          <template slot-scope="{ row }">
            <template v-if="row.assignment">
              <span class="ps-limit-value">{{ row.effectiveLimit | formatNumber }} HS</span>
              <span class="ps-package-cell__base">
                Gói {{ row.baseLimit | formatNumber }} + SL thêm {{ row.addonTotal | formatNumber }}
              </span>
            </template>
            <span v-else class="ps-row-muted">—</span>
          </template>
        </el-table-column>
        <el-table-column label="Số HS đang học" width="145" align="right">
          <template slot-scope="{ row }">
            <template v-if="row.assignment">
              <span class="ps-limit-value">{{ row.currentStudents | formatNumber }}</span>
              <span class="ps-package-cell__base">/ {{ row.effectiveLimit | formatNumber }} SL học sinh</span>
            </template>
            <span v-else>{{ row.currentStudents | formatNumber }}</span>
          </template>
        </el-table-column>
        <el-table-column label="% sử dụng" width="200">
          <template slot-scope="{ row }">
            <div v-if="row.assignment" class="ps-usage-cell">
              <div class="ps-usage-cell__numbers">
                <strong>{{ row.currentStudents | formatNumber }} / {{ row.effectiveLimit | formatNumber }}</strong>
                <span :class="{ 'is-danger': row.usagePercent >= 100 }">{{ formatPercent(row.usagePercent) }}%</span>
              </div>
              <el-progress
                :percentage="Math.min(row.usagePercent, 100)"
                :status="progressStatus(row)"
                :show-text="false"
                :stroke-width="7"
              />
            </div>
            <span v-else class="ps-row-muted">Chưa có giới hạn</span>
          </template>
        </el-table-column>
        <el-table-column label="Trạng thái" width="145" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="statusType(row)" size="small" effect="light">
              <i :class="statusIcon(row)" /> {{ statusLabel(row) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="Thông báo" width="135" align="center">
          <template slot-scope="{ row }">
            <el-tooltip
              :content="row.notifyEnabled ? 'Tắt thông báo cho trường' : 'Bật thông báo cho trường'"
              placement="top"
            >
              <el-switch
                :value="row.notifyEnabled"
                :disabled="row.notifySaving"
                active-color="#409eff"
                @change="toggleAlertNotify(row, $event)"
              />
            </el-tooltip>
            <span class="ps-notify-state" :class="{ 'is-off': !row.notifyEnabled }">
              {{ row.notifyEnabled ? "Đang bật" : "Đang tắt" }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="Cho phép vượt giới hạn" width="170" align="center">
          <template slot-scope="{ row }">
            <el-tooltip
              :content="row.allowExceedStudentLimit ? 'Tắt quyền cho phép vượt giới hạn' : 'Cho phép thêm học sinh vượt giới hạn gói'"
              placement="top"
            >
              <el-switch
                :value="row.allowExceedStudentLimit"
                :disabled="row.quotaOverrideSaving"
                active-color="#409eff"
                @change="toggleQuotaOverride(row, $event)"
              />
            </el-tooltip>
            <span class="ps-notify-state" :class="{ 'is-off': !row.allowExceedStudentLimit }">
              {{ row.allowExceedStudentLimit ? "Đang cho phép" : "Theo giới hạn gói" }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="Thao tác" width="225" align="center" fixed="right">
          <template slot-scope="{ row }">
            <div class="ps-action-row">
              <el-tooltip :content="row.assignment ? 'Đổi gói' : 'Áp dụng gói'" placement="top">
                <el-button type="primary" plain circle size="mini" icon="el-icon-connection" @click="openAssignDialog(row)" />
              </el-tooltip>
              <el-tooltip content="Thêm số lượng" placement="top">
                <el-button
                  type="success"
                  plain
                  circle
                  size="mini"
                  icon="el-icon-plus"
                  :disabled="!row.assignment"
                  @click="openAddonDialog(row)"
                />
              </el-tooltip>
              <el-tooltip content="Xem lịch sử thêm số lượng" placement="top">
                <el-button
                  type="info"
                  plain
                  circle
                  size="mini"
                  icon="el-icon-time"
                  :disabled="!row.assignment"
                  @click="openHistoryDialog(row)"
                />
              </el-tooltip>
              <el-tooltip content="Xem lịch sử sử dụng gói" placement="top">
                <el-button
                  type="warning"
                  plain
                  circle
                  size="mini"
                  icon="el-icon-document"
                  @click="openPackageHistoryDialog(row)"
                />
              </el-tooltip>
              <!-- Tạm ẩn nút test gửi thông báo theo từng trường. Giữ lại để bật lại khi cần. -->
<!--              &lt;!&ndash;-->
<!--              <el-tooltip content="Test gửi cảnh báo Firebase" placement="top">-->
<!--                <el-button-->
<!--                  type="danger"-->
<!--                  plain-->
<!--                  circle-->
<!--                  size="mini"-->
<!--                  icon="el-icon-bell"-->
<!--                  :disabled="!row.assignment"-->
<!--                  @click="openAlertTestDialog(row)"-->
<!--                />-->
<!--              </el-tooltip>-->
<!--              &ndash;&gt;-->
            </div>
          </template>
        </el-table-column>
        </el-table>
      </div>
      <div class="ps-pagination">
        <el-pagination
          small
          background
          layout="total, sizes, prev, pager, next"
          :current-page="currentPage"
          :page-size="pageSize"
          :page-sizes="[10, 20, 50]"
          :total="schoolTotal"
          @current-change="handlePageChange"
          @size-change="handlePageSizeChange"
        />
      </div>
    </section>

    <AssignPackageDialog
      :visible.sync="assignDialogVisible"
      :school-row="selectedRow"
      :packages="activePackages"
      :saving="saving"
      @submit="handleAssign"
    />
    <BulkAssignPackageDialog
      :visible.sync="bulkAssignDialogVisible"
      :schools="schoolOptions"
      :packages="activePackages"
      :saving="bulkSaving"
      @submit="handleBulkAssign"
    />
    <AddonDialog
      :visible.sync="addonDialogVisible"
      :school-row="selectedRow"
      :saving="saving"
      @submit="handleAddon"
    />
    <AddonHistoryDialog
      :visible.sync="historyDialogVisible"
      :school-row="selectedRow"
      :histories="histories"
      :loading="historyLoading"
    />
    <PackageUsageHistoryDialog
      :visible.sync="packageHistoryDialogVisible"
      :school-row="selectedRow"
      :histories="packageHistories"
      :loading="packageHistoryLoading"
    />
    <PackageLimitAlertTestDialog
      :visible.sync="alertTestDialogVisible"
      :school-row="selectedRow"
      :result="alertTestResult"
      :loading="alertTestLoading"
      @send="handleTestAlert"
    />
    <PackageLimitAlertConfigDialog
      :visible.sync="alertConfigDialogVisible"
      :config="alertConfig"
      :loading="alertConfigLoading"
      :saving="alertConfigSaving"
      @submit="handleSaveAlertConfig"
    />
  </div>
</template>

<script>
import AssignPackageDialog from "./components/dialog/AssignPackageDialog.vue";
import BulkAssignPackageDialog from "./components/dialog/BulkAssignPackageDialog.vue";
import AddonDialog from "./components/dialog/AddonDialog.vue";
import AddonHistoryDialog from "./components/dialog/AddonHistoryDialog.vue";
import PackageUsageHistoryDialog from "./components/dialog/PackageUsageHistoryDialog.vue";
import PackageLimitAlertTestDialog from "./components/dialog/PackageLimitAlertTestDialog.vue";
import PackageLimitAlertConfigDialog from "./components/dialog/PackageLimitAlertConfigDialog.vue";
import PackageService from "./services/PackageService";
import SchoolPackageService from "./services/SchoolPackageService";
import SchoolService from "@/services/SchoolService/SchoolService";

export default {
  name: "SchoolPackageAssignPage",
  components: {
    AssignPackageDialog,
    BulkAssignPackageDialog,
    AddonDialog,
    AddonHistoryDialog,
    PackageUsageHistoryDialog,
    PackageLimitAlertTestDialog,
    PackageLimitAlertConfigDialog,
  },
  data() {
    return {
      rows: [],
      packages: [],
      schoolTotal: 0,
      currentPage: 1,
      pageSize: 20,
      statistic: {},
      loading: false,
      saving: false,
      historyLoading: false,
      schoolId: "",
      schoolOptions: [],
      schoolOptionsLoading: false,
      statusFilter: "ALL",
      packageFilter: "",
      pageScrollEl: null,
      pageScrollTop: 0,
      heroHeight: 0,
      heroHidden: false,
      cardTopHeight: 0,
      statsGridHeight: 0,
      selectedRow: null,
      bulkAssignDialogVisible: false,
      bulkSaving: false,
      histories: [],
      assignDialogVisible: false,
      addonDialogVisible: false,
      historyDialogVisible: false,
      searchTimer: null,
      packageHistories: [],
      packageHistoryLoading: false,
      packageHistoryDialogVisible: false,
      alertTestDialogVisible: false,
      alertTestLoading: false,
      alertTestResult: null,
      alertConfigDialogVisible: false,
      alertConfigLoading: false,
      alertConfigSaving: false,
      alertConfig: null,
    };
  },
  computed: {
    activePackages() {
      return this.packages.filter((item) => item.active);
    },
    filteredRows() {
      return this.rows;
    },
    totalSchools() {
      return Number(this.statistic.totalSchoolsAssigned || 0)
        + Number(this.statistic.totalUnassigned || 0);
    },
    assignedCount() {
      return Number(this.statistic.totalSchoolsAssigned || 0);
    },
    fullCount() {
      return Number(this.statistic.totalFull || 0);
    },
    nearFullCount() {
      return Number(this.statistic.totalNearFull || 0);
    },
    statsStyle() {
      const collapseProgress = Math.min(this.pageScrollTop / 160, 1);
      return {
        opacity: 1 - collapseProgress,
        maxHeight: this.statsGridHeight
          ? `${this.statsGridHeight * (1 - collapseProgress)}px`
          : undefined,
        marginBottom: `${14 * (1 - collapseProgress)}px`,
        transform: `translateY(-${Math.min(this.pageScrollTop / 5, 10)}px)`,
      };
    },
    isHeroHidden() {
      return this.heroHidden;
    },
    cardLayoutStyle() {
      return {
        "--ps-card-top-height": `${this.cardTopHeight}px`,
      };
    },
  },
  created() {
    this.fetchSchoolOptions();
    this.fetchData();
  },
  mounted() {
    this.bindPageScroll();
    this.$nextTick(() => {
      this.measureStatsGrid();
      this.measureStickyHeights();
      this.handlePageScroll({ target: this.pageScrollEl });
    });
  },
  updated() {
    this.$nextTick(this.measureStickyHeights);
  },
  beforeDestroy() {
    clearTimeout(this.searchTimer);
    if (this.pageScrollEl) {
      this.pageScrollEl.removeEventListener("scroll", this.handlePageScroll);
    }
  },
  watch: {
    schoolId() {
      this.scheduleFetch();
    },
    statusFilter() {
      this.scheduleFetch();
    },
    packageFilter() {
      this.scheduleFetch();
    },
  },
  methods: {
    measureStatsGrid() {
      if (this.$refs.statsGrid) {
        this.statsGridHeight = this.$refs.statsGrid.scrollHeight;
      }
    },
    measureStickyHeights() {
      const heroHeight = this.$refs.pageHero ? this.$refs.pageHero.offsetHeight : 0;
      const cardTopHeight = this.$refs.cardTop ? this.$refs.cardTop.offsetHeight : 0;
      if (heroHeight && heroHeight !== this.heroHeight) this.heroHeight = heroHeight;
      if (cardTopHeight && cardTopHeight !== this.cardTopHeight) this.cardTopHeight = cardTopHeight;
    },
    bindPageScroll() {
      this.pageScrollEl = this.$el;
      if (this.pageScrollEl) {
        this.pageScrollEl.addEventListener("scroll", this.handlePageScroll, { passive: true });
      }
    },
    handlePageScroll(event) {
      if (event && event.target) {
        const nextScrollTop = Math.max(event.target.scrollTop, 0);
        this.pageScrollTop = nextScrollTop;
        if (nextScrollTop === 0) {
          this.heroHidden = false;
        } else if (this.heroHeight && nextScrollTop >= this.heroHeight) {
          this.heroHidden = true;
        }
      }
    },
    fetchSchoolOptions() {
      this.schoolOptionsLoading = true;
      SchoolService.getAllSchool()
        .then((response) => {
          const data = response && response.data ? response.data.data : [];
          this.schoolOptions = Array.isArray(data) ? data : [];
        })
        .catch((error) => this.showError(error))
        .finally(() => { this.schoolOptionsLoading = false; });
    },
    fetchData() {
      this.loading = true;
      const status = this.statusFilter === "ALL" ? undefined : this.statusFilter;
      Promise.all([
        SchoolPackageService.searchSchools({
          schoolId: this.schoolId,
          packageId: this.packageFilter,
          status,
          page: this.currentPage - 1,
          size: this.pageSize,
        }),
        PackageService.getAll(false),
        SchoolPackageService.getStatistic(),
      ])
        .then(([result, packages, statistic]) => {
          const packageById = packages.reduce((map, item) => {
            map[item.id] = item;
            return map;
          }, {});
          this.rows = result.items.map((row) => ({
            ...row,
            notifyEnabled: row.notifyEnabled !== false,
            notifySaving: false,
            allowExceedStudentLimit: row.allowExceedStudentLimit === true,
            quotaOverrideSaving: false,
            package: row.package
              ? {
                ...row.package,
                code: packageById[row.package.id]
                  ? packageById[row.package.id].code
                  : (row.package.code || ""),
                active: packageById[row.package.id]
                  ? packageById[row.package.id].active
                  : true,
              }
              : null,
          }));
          this.schoolTotal = result.total;
          this.packages = packages;
          this.statistic = statistic;
        })
        .catch((error) => this.showError(error))
        .finally(() => { this.loading = false; });
    },
    scheduleFetch() {
      this.currentPage = 1;
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => this.fetchData(), 300);
    },
    handlePageChange(page) {
      this.currentPage = page;
      this.fetchData();
    },
    handlePageSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
      this.fetchData();
    },
    statusKey(row) {
      return row.status || (row.assignment ? "CON_SLOT" : "CHUA_GAN");
    },
    statusLabel(row) {
      const labels = {
        CHUA_GAN: "Chưa áp dụng",
        CON_SLOT: "Còn số lượng",
        SAP_DAY: "Sắp đầy",
        DA_DAY: "Đã đầy",
      };
      return labels[this.statusKey(row)];
    },
    statusType(row) {
      const types = {
        CHUA_GAN: "info",
        CON_SLOT: "success",
        SAP_DAY: "warning",
        DA_DAY: "danger",
      };
      return types[this.statusKey(row)];
    },
    statusIcon(row) {
      const icons = {
        CHUA_GAN: "el-icon-minus",
        CON_SLOT: "el-icon-circle-check",
        SAP_DAY: "el-icon-warning-outline",
        DA_DAY: "el-icon-warning",
      };
      return icons[this.statusKey(row)];
    },
    progressStatus(row) {
      if (row.usagePercent >= 100) return "exception";
      if (row.usagePercent >= 90) return "warning";
      return "success";
    },
    formatPercent(value) {
      return Number(value || 0).toFixed(1);
    },
    openAssignDialog(row) {
      this.selectedRow = row;
      this.assignDialogVisible = true;
    },
    handleBulkAction(command) {
      if (command === "assign") {
        this.bulkAssignDialogVisible = true;
      }
    },
    openAddonDialog(row) {
      if (!row.assignment) return;
      this.selectedRow = row;
      this.addonDialogVisible = true;
    },
    openHistoryDialog(row) {
      if (!row.assignment) return;
      this.selectedRow = row;
      this.historyDialogVisible = true;
      this.historyLoading = true;
      SchoolPackageService.getAddonHistory(row.assignment.id)
        .then((data) => { this.histories = data; })
        .catch((error) => this.showError(error))
        .finally(() => { this.historyLoading = false; });
    },
    openPackageHistoryDialog(row) {
      this.selectedRow = row;
      this.packageHistories = [];
      this.packageHistoryDialogVisible = true;
      this.packageHistoryLoading = true;
      SchoolPackageService.getPackageHistory(row.school.id)
        .then((data) => { this.packageHistories = data; })
        .catch((error) => this.showError(error))
        .finally(() => { this.packageHistoryLoading = false; });
    },
    openAlertTestDialog(row) {
      if (!row.assignment) return;
      this.selectedRow = row;
      this.alertTestResult = null;
      this.alertTestDialogVisible = true;
    },
    openAlertConfigDialog() {
      this.alertConfigDialogVisible = true;
      this.alertConfigLoading = true;
      SchoolPackageService.getPackageLimitAlertConfig()
        .then((config) => { this.alertConfig = config; })
        .catch((error) => this.showError(error))
        .finally(() => { this.alertConfigLoading = false; });
    },
    handleSaveAlertConfig(config) {
      this.alertConfigSaving = true;
      SchoolPackageService.updatePackageLimitAlertConfig(config)
        .then((savedConfig) => {
          this.alertConfig = savedConfig;
          this.alertConfigDialogVisible = false;
          this.$message.success("Đã cập nhật cấu hình thông báo");
        })
        .catch((error) => this.showError(error))
        .finally(() => { this.alertConfigSaving = false; });
    },
    toggleAlertNotify(row, notifyEnabled) {
      if (!notifyEnabled) {
        this.$confirm(
          `Trường ${row.school.name} sẽ không nhận cảnh báo giới hạn gói cho đến khi được bật lại. Tiếp tục?`,
          "Xác nhận tắt thông báo",
          { type: "warning", confirmButtonText: "Tắt thông báo", cancelButtonText: "Hủy" },
        )
          .then(() => this.persistAlertNotify(row, false))
          .catch((error) => {
            if (error !== "cancel" && error !== "close") this.showError(error);
          });
        return;
      }
      this.persistAlertNotify(row, true);
    },
    persistAlertNotify(row, notifyEnabled) {
      const previousValue = row.notifyEnabled !== false;
      this.$set(row, "notifySaving", true);
      SchoolPackageService.updateSchoolPackageAlertConfig(row.school.id, notifyEnabled)
        .then((config) => {
          this.$set(row, "notifyEnabled", config.notifyEnabled !== false);
          this.$message.success(config.notifyEnabled
            ? "Đã bật thông báo cảnh báo cho trường"
            : "Đã tắt thông báo cảnh báo cho trường");
        })
        .catch((error) => {
          this.$set(row, "notifyEnabled", previousValue);
          this.showError(error);
        })
        .finally(() => { this.$set(row, "notifySaving", false); });
    },
    toggleQuotaOverride(row, allowExceedStudentLimit) {
      const allow = Boolean(allowExceedStudentLimit);
      let message;
      if (allow) {
        message = row.assignment
          ? `Trường ${row.school.name} sẽ được phép tiếp tục thêm học sinh vượt giới hạn hiệu lực hiện tại. Tiếp tục?`
          : `Trường ${row.school.name} chưa có gói đang áp dụng. Quyền vượt giới hạn sẽ có hiệu lực khi trường được gán gói. Tiếp tục lưu cấu hình?`;
      } else {
        message = row.assignment
          ? `Học sinh hiện đang học tại ${row.school.name} vẫn được giữ nguyên. Khi số lượng đang học bằng hoặc cao hơn giới hạn hiệu lực, các lượt thêm học sinh tiếp theo sẽ bị chặn. Tiếp tục?`
          : `Học sinh hiện tại vẫn được giữ nguyên. Khi trường được gán gói và số lượng đang học bằng hoặc cao hơn giới hạn hiệu lực, các lượt thêm học sinh tiếp theo sẽ bị chặn. Tiếp tục?`;
      }

      this.$confirm(message, allow ? "Cho phép vượt giới hạn" : "Tắt quyền vượt giới hạn", {
        type: allow ? "warning" : "info",
        confirmButtonText: "Xác nhận",
        cancelButtonText: "Hủy",
      })
        .then(() => this.persistQuotaOverride(row, allow))
        .catch((error) => {
          if (error !== "cancel" && error !== "close") this.showError(error);
        });
    },
    persistQuotaOverride(row, allowExceedStudentLimit) {
      const previousValue = row.allowExceedStudentLimit === true;
      this.$set(row, "quotaOverrideSaving", true);
      this.$set(row, "allowExceedStudentLimit", allowExceedStudentLimit);
      SchoolPackageService.updateStudentQuotaOverride(row.school.id, allowExceedStudentLimit)
        .then((config) => {
          this.$set(row, "allowExceedStudentLimit", config.allowExceedStudentLimit === true);
          this.$message.success(config.allowExceedStudentLimit
            ? "Đã cho phép trường vượt giới hạn gói"
            : "Đã tắt quyền vượt giới hạn gói cho trường");
        })
        .catch((error) => {
          this.$set(row, "allowExceedStudentLimit", previousValue);
          this.showError(error);
        })
        .finally(() => { this.$set(row, "quotaOverrideSaving", false); });
    },
    handleTestAlert(schoolId) {
      this.alertTestLoading = true;
      SchoolPackageService.testPackageLimitAlert(schoolId)
        .then((result) => {
          this.alertTestResult = result;
          if (result.sent) {
            this.$message.success(result.message || "Đã gửi thông báo test qua Firebase");
          } else {
            this.$message.warning(result.message || "API chưa gửi được thông báo test");
          }
        })
        .catch((error) => this.showError(error))
        .finally(() => { this.alertTestLoading = false; });
    },
    handleAssign(payload) {
      this.saving = true;
      const request = this.selectedRow && this.selectedRow.assignment
        ? SchoolPackageService.changePackage(payload.schoolId, payload.packageId)
        : SchoolPackageService.assignPackage(payload.schoolId, payload.packageId);
      request
        .then((result) => {
          if (result && result.failCount > 0) {
            this.$message.error(this.getBatchFailureMessage(result));
            return;
          }
          this.$message.success("Đã cập nhật gói áp dụng cho trường");
          this.assignDialogVisible = false;
          this.fetchData();
        })
        .catch((error) => this.showError(error))
        .finally(() => { this.saving = false; });
    },
    handleBulkAssign(payload) {
      this.bulkSaving = true;
      SchoolPackageService.assignPackageMany(payload.schoolIds, payload.packageId)
        .then((result) => {
          const results = result && Array.isArray(result.results) ? result.results : [];
          const failCount = Number(result && result.failCount !== undefined
            ? result.failCount
            : results.filter((item) => !item.success).length);
          const successCount = Number(result && result.successCount !== undefined
            ? result.successCount
            : results.filter((item) => item.success).length);
          if (failCount > 0) {
            this.$message.warning(
              `Đã áp dụng ${successCount}/${payload.schoolIds.length} trường; ${failCount} trường không thể áp dụng.`,
            );
          } else {
            this.$message.success(`Đã áp dụng gói cho ${payload.schoolIds.length} trường`);
          }
          this.bulkAssignDialogVisible = false;
          this.fetchData();
        })
        .catch((error) => this.showError(error))
        .finally(() => { this.bulkSaving = false; });
    },
    handleAddon(payload) {
      this.saving = true;
      SchoolPackageService.addAddon(payload.schoolPackageId, payload.amount, payload.note)
        .then(() => {
          this.$message.success(`Đã tăng giới hạn số lượng của trường thêm ${payload.amount}`);
          this.addonDialogVisible = false;
          this.fetchData();
        })
        .catch((error) => this.showError(error))
        .finally(() => { this.saving = false; });
    },
    showError(error) {
      const responseMessage = error && error.response && error.response.data
        ? error.response.data.message
        : null;
      this.$message.error(responseMessage || (error && error.message)
        || "Có lỗi xảy ra, vui lòng thử lại");
    },
    getBatchFailureMessage(result) {
      const failed = (result.results || []).find((item) => !item.success);
      return failed && failed.message
        ? failed.message
        : "Không thể cập nhật gói cho trường";
    },
  },
};
</script>

<style lang="scss">
@import "./styles/package-student.scss";

.package-student-page--assign .ps-school-cell__text {
  min-width: 0;
  flex: 1;
}

.package-student-page--assign .ps-school-cell__name,
.package-student-page--assign .ps-package-name {
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: normal;
}

.package-student-page--assign .ps-package-code {
  max-width: 100%;
  white-space: normal;
  overflow-wrap: anywhere;
}
</style>
